import React, { useEffect, useState } from "react";
import Button from "../../../components/common/button";
import { InstructionalModalProps } from "../types";
import { getLocalStorage } from "../../../utils/common-function";
import { Stashlink } from "../../../types";
import { isAmazonCampaign, isNativeWebview } from "../../../common/constants";
import Tree2Icon from "./treeIcon/2tree";
import useGameSounds from "../hooks/useGameSounds";

const InstructionalModal: React.FC<InstructionalModalProps> = ({ isOpen, onClose, brandName }) => {
  if (!isOpen) return null;
  const stashlink = getLocalStorage("stashlink") as Stashlink;
  const isAmazon = isAmazonCampaign(stashlink?.id);
  const { playMoneySound } = useGameSounds();

  const [showCoin, setShowCoin] = useState(false);
  const [demoBubbles, setDemoBubbles] = useState(Array(4).fill({ revealed: false }));
  const isAllRevealed = demoBubbles.every((b) => b.revealed);

  useEffect(() => {
    if (isAllRevealed) {
      const timer = setTimeout(() => {
        onClose();
      }, 400); // Wait for animation and sound
      return () => clearTimeout(timer);
    }
  }, [isAllRevealed, onClose]);

  const handleCoinClick = () => {
    // If coin is already showing, reset it
    if (showCoin) {
      setShowCoin(false);
      // Small delay to ensure state updates before showing again
      setTimeout(() => {
        setShowCoin(true);
      }, 10);
    } else {
      setShowCoin(true);
    }
  };

  return (
    <div
      className={`fixed inset-0 bg-black/60 flex justify-center z-[100] backdrop-blur ${isNativeWebview() ? "pt-32 items-start" : "items-center"}`}>
      <div className="bg-grey-bg text-base-white rounded-3xl w-80 relative border-r-4 border-b-4 border-primary-l1">
        <div className="bg-black/0 px-4 py-6 pb-4 pt-6 rounded-2xl">
          <div className="flex items-center justify-center mb-4 gap-2">
            {isAmazon && <Tree2Icon width={40} />}
            <h2 className="text-22px text-base-white font-bold text-center">{isAmazon ? `How to plant` : `How to Stash`}</h2>
            {isAmazon && <Tree2Icon width={40} />}
          </div>
          <div className="relative bg-black/30 px-4 py-1 pt-3 rounded-2xl">
            <p className="text-center text-base text-neutral-50 font-nunito leading-tight mb-4">
              Tap the coins as <br /> fast as you can {isAmazon ? `to stash them` : null}.
            </p>

            <div className="flex justify-center gap-4 mb-6 mt-6">
              {demoBubbles.map((bubble, index) => (
                <div
                  key={index}
                  onClick={() => {
                    if (!bubble.revealed) playMoneySound();
                    setDemoBubbles((prev) => prev.map((b, i) => (i === index ? { ...b, revealed: true } : b)));
                    handleCoinClick();
                  }}
                  onTouchStart={(e) => {
                    // Prevent default to avoid double firing on touch devices that also fire mouse events
                    e.preventDefault();
                    if (!bubble.revealed) playMoneySound();
                    setDemoBubbles((prev) => prev.map((b, i) => (i === index ? { ...b, revealed: true } : b)));
                    handleCoinClick();
                  }}
                  className={`${bubble.revealed ? "flipping revealed-coin" : "coin"}`}>
                  {bubble.revealed && (
                    <div className="w-10 h-10 rounded-full flex items-center justify-center cursor-pointer bg-gray-500/30"></div>
                  )}
                </div>
              ))}
            </div>

            {/* <div className="flex justify-between items-start mb-4">
              <div className="w-10 h-10 bg-grey-op70/30 rounded-full flex items-center justify-center"></div>

              <div className="w-10 h-10 bg-grey-op70/300 rounded-full flex items-center justify-center shadow-[0_5px_0px_rgba(0,0,0,1)]">
                <img className="w-10 h-10 flex items-center justify-center object-cover object-top rounded-full" src={Coin} />
              </div>
              <div className="w-10 h-10 bg-grey-op70/30 rounded-full"></div>
              <div className="w-10 h-10 bg-grey-op70/30 rounded-full"></div>
              <div className="w-10 h-10 bg-grey-op70/30 rounded-full flex items-center justify-center shadow-[0_5px_0px_rgba(0,0,0,1)]">
                <img className="w-10 h-10 flex items-center justify-center object-cover object-top rounded-full" src={Coin} />
              </div>
            </div> */}
            {/* <img src={base64HandIcon} alt="Hand Icon" className="absolute -bottom-4 -right-10 w-20 -rotate-[130deg]" /> */}
          </div>
          {isAmazon ? (
            <p className="text-center text-base text-neutral-50 leading-tight mb-4 mt-4">
              Coins unlock sponsor-funded <br />
              <span className="text-primary-l1"> trees planted in the Amazon </span>
            </p>
          ) : (
            <p className="text-center text-base text-neutral-50 leading-tight mb-4 mt-4">
              Every coin you tap is <span className="text-primary-l1 font-bold">real money</span> donated by{" "}
              <span className="font-bold">{brandName}</span>
            </p>
          )}
          <Button title={isAmazon ? "Play" : "Got it!"} isDisabled={false} onClick={onClose} />
          {isAmazon ? <p className="text-center text-base font-semibold text-light-grey leading-tight my-6">Planted by Re:Wild</p> : null}
        </div>
      </div>
    </div>
  );
};

export default InstructionalModal;
